<template>
	<div class="mainLeft">
		<publicColumn :info="info"/>
		<publicList :arr="data"/>
		<publicPageNumber :total="totals" :cur="cur" @changePage="getDatas"/>
	</div>
</template>

<script>
	import publicColumn from '@/components/common/column'
	import publicList from '@/components/common/list'
	import publicPageNumber from '@/components/common/pageNumber'
	
	import axios from '@/axios/'
	
	export default{
		props:{
			info:{
				required:false,
				type:Object
			}
		},
		components:{
			publicColumn,publicList,publicPageNumber
		},
		data(){
			return{
				data:[],
				cur:1,
				totals:1
			}
		},
		created(){
			this.getDatas(1);
		},
		methods:{
			async getDatas(cur){
				try{
					let {data} = await axios('/moment/list',{
						params:{
							pageNumber:cur,
						}
					});
					if(data.code==200){
						this.data = data.data;
						this.totals = data.total;
					}
				}catch(e){
					//
				}
			}
		},
	}
</script>

<style scoped>
	.mainLeft {
		width: 950px;
		float: left;
	}
</style>
